import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { INITIAL_BASIC_INFO } from './consts';
import { setBasicInfo, reset, setLoading } from './actions';

const basicInfoReducer = handleActions(
  {
    [setBasicInfo.toString()]: (_, { payload: basicInfo }) => basicInfo,
    [reset.toString()]: () => INITIAL_BASIC_INFO
  },
  INITIAL_BASIC_INFO
);

const loadingReducer = handleActions(
  {
    [setLoading.toString()]: (_, { payload: loading }) => loading,
    [reset.toString()]: () => false
  },
  false
);

export default combineReducers({
  basicInfo: basicInfoReducer,
  loading: loadingReducer
});
